import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nt-layer-panel',
  templateUrl: './layer-panel.component.html',
  styleUrls: ['./layer-panel.component.scss']
})
export class LayerPanelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
